import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectConfig } from '../../entities/select-config';
import {HttpService} from '../../services/http/http-service.service';

@Component({
  selector: 'app-s-linkage',
  templateUrl: './s-linkage.component.html',
  styleUrls: ['./s-linkage.component.less']
})
export class SLinkageComponent implements OnInit {

  @Input() optionList;
  constructor(
    private httpService: HttpService
  ) { }
  filterOPtions: any = [];
  childrenList: any = [];
  compareFn = (o1: any, o2: any) => o1 && o2 ? o1.value === o2.value : o1 === o2;

  ngOnInit(): void {
  }

  getOptionData(obj) {
    if (obj.url) {
      if (obj.params) {
        this.httpService.httpGet(obj.url, obj.params).subscribe(res => {
          if (res.code === 1) {
            obj.data = this.renderOptionList(obj, res.data);
          }
        });
      }
    } else {
      console.log('重新请求数据');
    }
    return obj;
  }

  renderOptionList(obj, data) {
    obj.data = [];
    if (data.length) {
      data.forEach((item) => {
        if (obj.name) {
          item.label = item[obj.name];
        }
        if (obj.value) {
          item.value = item[obj.value];
        }
        item.id = obj.id ? obj.id : null;
        item.key = obj.key ? obj.key : null;
        item.children = obj.children ? obj.children : null;
        item.parent = obj.parent ? obj.parent : null;
      });
    }
    return data;
  }

  setChildrenParams(item) {
    if (item.children && item.parent) {
      const children =  this.optionList.filter((a) => {
        return a.parent && a.parent === item.id;
      });
      if (children.length) {
        children.forEach((c) => {
          c.params = item.params;
          this.setChildrenParams(c);
        });
      }
    }
  }

  clearChildren(item) {
   if (item.children && item.parent) {
    const children =  this.optionList.filter((a) => {
      return a.parent && a.parent === item.id;
    });
    if (children.length) {
      children.forEach((c) => {
        c.selectedValue = null;
        c.data = [];
        c.params = {};
        this.clearChildren(c);
      });
    }
   }
  }

  optionChange(options: SelectConfig, e: any) {
    if (!e) {

    }
    const allChildrenComponents = this.optionList.filter((fItem) => {
      return fItem.parent === options.id;
    });
    if (!e) {
      allChildrenComponents.forEach((aItem) => {
        aItem.selectedValue = null;
        aItem.data = [];
        aItem.params = {};
        this.clearChildren(aItem);
      });
    } else if (e && e.children) {
      allChildrenComponents.forEach((cItem) => {
        cItem.params[options.key] = e.value;
        if (e.parent) {
          cItem.params = options.params;
        }
        cItem.defaultLoad = true;
        cItem = this.getOptionData(cItem);
        this.setChildrenParams(cItem);
      });

    }
  }
}
